/**
 * Bare flow paths (`/rfq`, `/suppliers`, `/compare`, `/quote`, `/revisions` — no `:id`)
 * redirect to the last enquiry the user actually opened this session, or to the Requirements
 * board when none has been opened yet. Never to an invented id — see `lib/activeEnquiry.ts`.
 */

import { Navigate } from 'react-router-dom'
import { useActiveEnquiry } from '../components/ActiveEnquiryProvider'
import { flowLinkTarget, resolveActiveEnquiryId } from '../lib/activeEnquiry'

export function FlowRedirect({ base }: { base: string }) {
  const { lastEnquiryId } = useActiveEnquiry()
  const activeId = resolveActiveEnquiryId(undefined, lastEnquiryId)
  return <Navigate to={flowLinkTarget(base, activeId)} replace />
}
